export const environment = {
  production: false,
  apiBaseUrl: "https://testml.wideum.com",
  supervisorApiUrl: "https://magicapi.remoteeye.com",
  predictionMinimumScore: 50,
};
